import { createPaywallApi } from '@forest/paywall-core'
import { userInfoSource } from '~/store'

export const api = createPaywallApi({ userInfo: userInfoSource })
